
<template>
    <footer>
        <div class="">
            <app-system-author :author="author"></app-system-author>
        </div>
    </footer>
</template>

<script>
import SystemAuthor from './SystemAuthor.vue'
import global_resources from './global_resources';
export default {
    data(){
        return{
            postadress:'Falköpings kommun, 521 81 Falköping',
            besoksadress:'Besöksadress: Stadshuset, S:t Sigfridsgatan 9',
            telefon:'0515-88 50 00',
            author:{
                text:'Ett projektsamarbete mellan Högskolan i Skövde, Samhällsskydd Mellersta Skaraborg och Falköpings kommun',
                version: '| v. ' + global_resources.global_vars.app_version,
                }
        };
    },
     components: {
            appSystemAuthor: SystemAuthor
        }

};
</script>
<style scoped>
    footer {
        width: 100%;
        height: 50px;
        font-size: 1.4rem;
        display: block;
        position: fixed;
        color: #FFF;
        background-color: rgba(0, 0, 0, 0.05);
        padding: 0.3em 0 0.5em;
        bottom: 0px;
        text-align: center;
        border-top: 3px solid rgba(0,0,0,0.1);
    }
footer > _div {
    display: block;
    width: 100%;
    max-width: calc(1280px + 2.5%);
    margin: auto;
    padding-left: 15px;
}

.fk-adress{
    font-size: 1.3rem;
    /* margin-left: auto;
    margin-right: auto; */
}
.fk-flleft{
    padding: 0 0.5%;
    float: left;
    display: block;
    margin-right: 1.5rem;

}
.fk-flleft > p{
    padding: 0;
    margin:0;
}
.fk-flleft > p >i{
    vertical-align: middle;
}

    footer .footer-copyright {
        margin-left: 32px;
        font-size: 1.2rem;
        color: rgba(0,0,0,0.5);
    }

</style>



// WEBPACK FOOTER //
// src/Footer.vue